<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M12.18 9.67c-1.77 0-3.37.66-4.6 1.73L5.18 9v6h6l-2.42-2.41A5.3 5.3 0 0 1 17.24 15l1.58-.52a7 7 0 0 0-6.64-4.81"
      />
    </svg>
  </span>
</template>
